import { SET_PCBNET_QUOTE_DETAILS } from '../../constants/ActionConstants';

export const setPCBNetQuoteDetails = (pcbNetQuoteDetails) => ({
    type: SET_PCBNET_QUOTE_DETAILS,
    data: { pcbNetQuoteDetails: pcbNetQuoteDetails }
});
